import React from 'react';
import { Link } from 'react-router-dom';
import type { LucideIcon } from 'lucide-react';
type Variant = 'orange' | 'white' | 'outline' | 'navy';
type Size = 'sm' | 'md';
interface PillButtonProps {
  to?: string;
  href?: string;
  onClick?: () => void;
  variant?: Variant;
  size?: Size;
  icon?: LucideIcon;
  iconPosition?: 'left' | 'right';
  className?: string;
  children: React.ReactNode;
}

/** L'orange de Beaconsfield porte du texte blanc, jamais du texte foncé. */
const variants: Record<Variant, string> = {
  orange: 'bg-ville-lime text-white hover:-translate-y-0.5 focus-visible:ring-ville-lime',
  white: 'bg-white text-ville-navy hover:-translate-y-0.5 focus-visible:ring-white',
  navy: 'bg-ville-navy text-white hover:-translate-y-0.5 focus-visible:ring-ville-navy',
  outline: 'border border-ville-navy/25 text-ville-navy hover:border-ville-navy hover:bg-ville-navy hover:text-white focus-visible:ring-ville-navy'
};
const sizes: Record<Size, string> = {
  sm: 'px-4 py-2 text-sm',
  md: 'px-6 py-3 text-[15px]'
};
export function PillButton({
  to,
  href,
  onClick,
  variant = 'orange',
  size = 'md',
  icon: Icon,
  iconPosition = 'right',
  className = '',
  children
}: PillButtonProps) {
  const classes = `inline-flex shrink-0 items-center justify-center gap-2 rounded-full font-bold transition-[transform,background-color,color,border-color] duration-150 ease-ville focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 ${variants[variant]} ${sizes[size]} ${className}`;
  const content = <>
      {Icon && iconPosition === 'left' && <Icon className="h-4 w-4" aria-hidden="true" data-id="element-2861" data-mp="2bcprq2dw2n81" />}
      {children}
      {Icon && iconPosition === 'right' && <Icon className="h-4 w-4" aria-hidden="true" data-id="element-2862" data-mp="2fe19jlqiu45o" />}
    </>;
  if (to) {
    return <Link to={to} className={classes} data-id="element-2863" data-mp="zxkew5k1n8ap">
        {content}
      </Link>;
  }
  if (href) {
    return <a href={href} className={classes} data-id="element-2864" data-mp="13znospr2e4tv">
        {content}
      </a>;
  }
  return <button type="button" onClick={onClick} className={classes} data-id="element-2865" data-mp="36ljmel60tv9j">
      {content}
    </button>;
}